var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.fileUrl,"target":"_blank"},on:{"click":_vm.onClick}},[_c('pdf',{staticStyle:{"height":"310px","width":"240px"},attrs:{"id":"pdf-container","src":_vm.fileUrl}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }